declare global {
  interface Window { __ENV__?: Record<string, string> }
}

function runtimeKey(name: string): string {
  return name.replace(/^VITE_/, 'APP_')
}

function getEnv(name: string): string | undefined {
  const rt = window.__ENV__?.[runtimeKey(name)]?.trim()
  if (rt) return rt
  return (import.meta.env as Record<string, string | undefined>)[name]?.trim()
}

export function requiredEnv(name: string): string {
  const value = getEnv(name)
  if (!value) throw new Error(`Variável ausente: ${name} (runtime: ${runtimeKey(name)})`)
  return value
}

export function optionalEnv(name: string, fallback = ''): string {
  return getEnv(name) || fallback
}
